import React from "react";
import Box from "@mui/material/Box";

const LOGO_SRC = "/assets/logos/hoarding-life_logo.webp";

export default function LogoSpinner({
  size = 28,
  alt = "Loading",
  sx,
  className,
  style,
  ...rest
}) {
  return (
    <Box
      component="img"
      src={LOGO_SRC}
      alt={alt}
      className={className}
      style={style}
      sx={{
        width: size,
        height: size,
        display: "inline-block",
        transformOrigin: "center center",
        backfaceVisibility: "visible",
        animation: "logoSpinnerFlip 2.4s ease-in-out infinite",
        "@keyframes logoSpinnerFlip": {
          "0%": { transform: "rotateY(0deg) scale(1)" },
          "25%": { transform: "rotateY(10deg) scale(1.01)" },
          "50%": { transform: "rotateY(180deg) scale(1.02)" },
          "75%": { transform: "rotateY(350deg) scale(1.01)" },
          "100%": { transform: "rotateY(360deg) scale(1)" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          animation: "none",
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
